export default "__VITE_ASSET__6aed2bd8__"